import SuspectEmailCaptureForm from './suspectEmailCaptureForm';

export default SuspectEmailCaptureForm;

